<template>
    <div>{{ this.$t('components.miscellaneous.addNameDialog.content') }}</div>
</template>

<script>
export default {
    name: 'AddNameDialog',
};
</script>

<style></style>
